import buildCJAAccountPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { getModuleTrackingPageType } from '../helpers/Utils/utils';

export const buildCJALinkClick = (params = {}) => ({
    eventName: 'linkClick',
    payload: {
        event_name: 'linkClick',
        linkComponent: getModuleTrackingPageType(window?.location?.pathname || ''),
        linkId: '',
        linkText: '',
        linkType: 'other',
        linkUrl: window?.location?.pathname || '',
        linkModuleName: '',
        linkRegion: '',
        linkPosition: 0,
        ...params,
    },
});

export const buildCJAImpression = (params = {}) => ({
    eventName: 'impressions',
    payload: {
        event_name: 'impressions',
        impressionId: '',
        impressionName: '',
        impressionType: '',
        ...params,
    },
});

export const buildCJAError = (errors) => {
    const pageType = getModuleTrackingPageType(window?.location?.pathname || '');
    const errorList = Array.isArray(errors) ? errors : [errors || {}];
    return {
        eventName: 'error',
        payload: {
            event_name: 'error',
            error: errorList.map((e) => ({
                type: `${pageType}:${e.errorType || e.type || 'error'}`,
                id: e.errorID || e.errorCode || '',
                message: e.errorDescription || e.errorMessage || '',
            })),
        },
    };
};

export const getCJAPageName = () => {
    const dataLayer = window?.adobeDataLayer || [];
    for (let i = dataLayer.length - 1; i >= 0; i -= 1) {
        if (dataLayer[i]?.event === 'pageView') {
            return dataLayer[i]?.page?.name || '';
        }
    }
    return '';
};

export const buildCJAAccountPageView = (pageName, params = {}) => ({
    eventName: 'pageView',
    payload: buildCJAAccountPageViewPayload({
        name: pageName || '',
        type: 'account',
        siteSection: 'account',
        ...params,
    }),
});
